import React from "react";
import { Link } from "@quintype/components";
import "./RelatedLinks.m.css";

const RelatedLinks = ({ state }) => {
  const hijriMonth = state?.cityPrayerTodayTime?.hijri_month;

  const mappedCountryUrl = {
    uae: "/ramadan-prayer-timings",
    saudi: "/ramadan-prayer-timings-riyadh",
    qatar: "/ramadan-prayer-timings-qatar",
    kuwait: "/ramadan-prayer-timings-kuwait",
    oman: "/ramadan-prayer-timings-oman",
    bahrain: "/ramadan-prayer-timings-bahrain",
  };

  const ramadanPrayerUrl = mappedCountryUrl[state?.selectedCountry?.toLowerCase()] || "/ramadan-prayer-timings";

  if (hijriMonth?.toLowerCase() !== "ramadan" && hijriMonth?.toLowerCase() !== "sha'ban") {
    return null;
  }

  return (
    <div styleName="prayer-times-related-links">
      <Link href={ramadanPrayerUrl}>Ramadan Prayer Timings</Link>
      <Link href="/zakat-calculator">Calculate Your Zakat</Link>
    </div>
  );
};

export default RelatedLinks;
